/* ============================================================
   sm-hurda-resize.js

   Stillirinn hvarf þegar glugginn var minnkaður í símabreidd án
   þess að endurhlaða. Mælt 2026-09-22, fyrst við 1024px og svo
   375px án endurhleðslu: .pdp-hurda fór í 0x0 og display:none,
   meðan hausinn brást rétt við (942 niður í 335). Notandinn þurfti
   að endurhlaða til að fá viðmótið.

   ÁSTÆÐAN: eina reglan sem BIRTIR stillinn undir 1000px er
   `body.hs-open .pdp-hurda` í sm-hurda-steps.css. Vanti klasann
   hs-open gildir `.pdp-hurda { display:none !important }` úr sömu
   skrá og síðan er auð. Klasinn kemur frá openWiz() í
   sm-hurda-steps.js, sem byrjar á `mq() &&` og gerir því ekkert
   nema breiddin sé ÞEGAR undir 1000px. sm-hurda-inline.js smellir
   sjálfvirkt á [data-hs-open] við hleðslu, svo ferskt símaálag
   virkar, en á borðtölvu er hs-open aldrei settur og ekkert
   endurmetur hann þegar glugginn breytist.

   LAUSNIN: hlusta á þröskuldinn sjálfan.

   AÐEINS BÆTT VIÐ, ALDREI FJARLÆGT. Tvær ástæður. Allar
   body.hs-open reglur í þemanu liggja inni í @media
   (max-width:1000px), svo klasinn gerir bókstaflega ekkert á
   borðtölvu og má liggja eftir. Og að fjarlægja hann væri hvort eð
   er tilgangslaust: sm-hurda-inline.js keyrir MutationObserver á
   body sem setur hann strax aftur um leið og klasalistinn breytist.
   ============================================================ */
(function () {
  var mq = window.matchMedia('(max-width: 1000px)');

  function sync() {
    if (!mq.matches) return;
    if (!document.querySelector('.pdp-hurda')) return;

    document.body.classList.add('hs-open');

    /* hideRest() í sm-hurda-steps.js felur systkini síðunnar með
       .hs-away og reveal() í sm-hurda-inline.js tekur þau aftur.
       Við ferska símahleðslu mælist fjöldi .hs-away núll, svo
       lokastaðan er hrein. Hér er hreinsað til ef eitthvað sat
       eftir eftir ferð yfir þröskuldinn. */
    var away = document.getElementsByClassName('hs-away');
    while (away.length) {
      away[0].classList.remove('hs-away');
    }
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
})();
